module.exports = __webpack_public_path__ + "static/media/windows-11.73560fd2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/windows-11.svg
// module id = 47
// module chunks = 0